module.exports = __webpack_public_path__ + "static/media/facebook.6cadc594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/CreateCampaign/components/CreateCampaignForm/assets/facebook.svg
// module id = 1283
// module chunks = 0